import { DeskingSubmitOptions } from "modules/desking/types";
import { CreateLeadProposalVariables } from "../api/types";

export function generateCreateLeadProposalLeadDTO(
  contact: DeskingSubmitOptions["form"]["contact"]
): CreateLeadProposalVariables["input"]["leadDTO"] {
  if (contact.selectedContact) {
    return {
      attach: contact.selectedContact,
    };
  }

  return {
    createData: {
      email: contact.email,
      phone: contact.phone,
      title: contact.title,
      fullName: contact.fullName ?? null,
      businessName: contact.businessName ?? null,
    },
  };
}
